
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import toast from "react-hot-toast";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { fetchGenders } from "../../redux/actions/genderActions";
import { fetchCityData } from "../../redux/actions/citiesAction";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import axios from "../../API/axios";
import { useNavigate, useParams } from "react-router-dom";
import { fetchLanguage } from "../../redux/actions/LanguageAction";


function EditCandidByInst() {
	const sessionId = localStorage.getItem("sessionId");
	const { CandidateId } = useParams();

	// ...............................PROFILE Start.......................................
	// State variables
	const navigate = useNavigate();
	const [displays, setDisplays] = useState(false);
	const [langValue, setLangValue] = useState("");
	const [email, setEmail] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [startDate, setStartDate] = useState("");
	const [headLine, setHeadLine] = useState("");
	const [activeAs, setActiveAs] = useState("");
	const [orgType, setOrgType] = useState("");
	const [website, setWebsite] = useState("");
	const [about, setAbout] = useState("");
	const [profileImage, setProfileImage] = useState(null);
	const [profileImageview, setProfileImageview] = useState("");
	const [error, setError] = useState(null);

	const [selectedBatch, setSelectedBatch] = useState(null);
	const [selectedClass, setSelectedClass] = useState(null);
	const [className, setClassName] = useState(null);
	const [classId, setClassId] = useState(null);
	const [batchName, setBatchName] = useState(null);
	const [phonenum, setPhonenum] = useState("");
	const [address, setAddress] = useState("");
	const [batchList, setBatchList] = useState("");
	const [ClassList, setClassList] = useState("");
	console.log("selectedBatch", selectedBatch);
	console.log("batchName", batchName);

	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	console.log("selectedClass", selectedClass);

	const [userData, setUserData] = useState([]);
	console.log('bnbnbs', batchName, selectedBatch);
	console.log('bnbnbs', batchName, typeof (selectedBatch));


	const getUserDetail = () => {
		axios
			.get(`/Candidate/GetProfile?UID=${CandidateId}`)
			.then((response) => {
				const res = response.data.responseData;
				setUserData(res);
				console.log("GetProfile", res);

			})
			.catch((error) => {
				if (error.response && error.response.status === 404) {
					console.log(error);
				} else {
					console.log(error);
				}
			});
	};

	useEffect(() => {
		getUserDetail();
	}, []);

	console.log("userData", userData);

	//************************Batch Get Start  ************************//

	const GetCandidateClass = () => {
		const data = {
			sessionId: sessionId,
			name: "",
			type: "Class",
		};
		console.log("class data", data);

		axios
			.post(`/Institute/GetCandidateClasses`, data)
			.then((response) => {
				console.log("Class data", response.data.responseData);
				const res = response.data.responseData;
				const data = res.map((item) => ({
					value: item.id,
					label: item.name,
				}));
				setClassList(data);
				console.log("setClassList", data);

			})
			.catch((error) => {
				console.log(error);
			});
	};
	useEffect(() => {
		GetCandidateClass();
	}, []);

	const GetCandidateBatch = () => {
		const data = {
			sessionId: sessionId,
			name: "",
			type: "Batch",
		};
		axios
			.post(`/Institute/GetCandidateClasses`, data)
			.then((response) => {
				console.log("Batch data=====>", response.data.responseData);
				const res = response.data.responseData;
				console.log("selectedBatch===?", res);
				const data = res.map((item) => ({
					value: item.id,
					label: item.name,

				}));
				setBatchList(data);
				console.log("setBatchList", data);

			})
			.catch((error) => {
				console.log(error);
			});
	};
	useEffect(() => {
		GetCandidateBatch();
	}, []);

	//************************Batch Get End  ************************//


	// Handle Profile Image Change
	const handleProfileImageChange = (event) => {
		const selectedFile = event.target.files[0];
		const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

		if (selectedFile) {
			// Validate file type
			if (!validImageTypes.includes(selectedFile.type)) {
				setError('Only JPEG and PNG images are allowed.');
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// Validate file size (limit to 2MB)
			const maxSizeInMB = 10;
			if (selectedFile.size > maxSizeInMB * 1024 * 1024) {
				setError(`File size should not exceed ${maxSizeInMB}MB.`);
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// If valid, update the state
			setProfileImage(selectedFile);
			setProfileImageview(URL.createObjectURL(selectedFile));
			setError(null);
		}
	};

	// .......................... Edit-Candid Disabled and Enabaled

	// Function to handle field changes and set formChanged to true
	// const handleFieldChange = (setter, value) => {
	// 	setter(value);
	// 	setFormChanged(true);
	// };

	// ..............................  Edit-Candid Disabled and Enabaled


	const Profile = async (e) => {
		e.preventDefault();
		try {
			setDisplays(true);
			// setIsSubmitting(true); // Disable the button during submission
			if (
				// langValue &&
				genderValue &&
				phonenum &&
				city &&
				// headLine &&
				startDate &&
				profileImage !== ""

			) {
				const formData = new FormData();
				formData.append("InstnCnddtId", userData.insttCandidateProfile.instnCnddtId);
				formData.append("ClssID", selectedClass);
				formData.append("BtchID", selectedBatch);
				formData.append("LangId", 2);
				formData.append("GenderId", genderValue);
				formData.append("CityId", city);
				formData.append("Dob", startDate ? moment(startDate).format("YYYY-MM-DD") : "");
				formData.append("ProfileImage", profileImage);
				formData.append("FirstName", firstName);
				formData.append("LastName", lastName);
				formData.append("PhoneNumber", phonenum);
				formData.append("Address", address);
				formData.append("Email", email);
				formData.append("HeadLine", headLine);
				formData.append("About", about);
				formData.append("Website", website);
				formData.append("SessionId", sessionId);

				console.log("Profile FormData:", formData);
				const res = await axios.post("/Candidate/UpdateInsttCandidateProfile", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});

				console.log("Profile Response:", res);
				toast.success(res.data.message);
				setLangValue("");
				setStartDate("");
				setCity("");
				setPhonenum("");
				setAddress("");
				setGenderValue("");
				setProfileImage("");
				setProfileImageview("");
				setDisplays(false);
				navigate("/Institute/Candidate/All");
				// setFormChanged(false); // Disable the button after successful update
			} else {
				toast.error("Please enter all required fields!");
			}
		} catch (error) {
			if (error.response.status === 400) {
				toast.error(error.response.data.message)
			} else if (error.response.status === 415) {
				toast.error(error.response.data.title);
			} else {
				toast.error(error.response.data.message);
			}
			console.error(error)
		} finally {
			// setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};

	// ...............................PROFILE End.......................................

	// ...............................Gender DDL.......................................

	const [genderValue, setGenderValue] = useState(null);
	const dispatch = useDispatch();
	const { genderOptions } = useSelector(
		(state) => state.gender
	);
	useEffect(() => {
		dispatch(fetchGenders());
	}, [dispatch]);

	// ...............................Gender DDL.......................................
	// ...............................City DDL.......................................
	const [city, setCity] = useState(null);
	const { cityList } = useSelector((state) => state.cities);
	useEffect(() => {
		dispatch(fetchCityData());
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		dispatch(fetchCityData(inputValue));
	};

	// ...............................City DDL.......................................

	// ...............................Language DDL.......................................
	const { LanguageList } = useSelector(
		(state) => state.language
	);
	useEffect(() => {
		dispatch(fetchLanguage());
	}, [dispatch]);

	const handleLanguageSelect = (selectedOption) => {
		if (selectedOption) {
			setLangValue(selectedOption.value);
		} else {
			setLangValue(null);
		}
		setLangValue(selectedOption.value);
	};
	// ...............................Language DDL.......................................

	useEffect(() => {
		if (userData) {
			setLangValue(userData?.langId);
			dispatch(fetchLanguage(userData.langName));
			setGenderValue(userData?.genderId);
			setAddress(userData?.candidateProfileInfo?.address);
			setPhonenum(userData?.phoneNumber);
			dispatch(fetchGenders(userData.genderName));
			setStartDate(userData?.dob);
			setCity(userData?.cityId);
			dispatch(fetchCityData(userData.cityName));
			setCity(userData?.cityId);
			setProfileImageview(userData?.profileImage);
			setProfileImage(userData?.profileImage)
			setAbout(userData?.candidateProfileInfo?.about)
			setWebsite(userData?.candidateProfileInfo?.website)
			setHeadLine(userData?.candidateProfileInfo?.headLine);
			setActiveAs(userData?.candidateProfileInfo?.activeAs);
			setOrgType(userData?.candidateProfileInfo?.orgType);
			setFirstName(userData?.firstName)
			setLastName(userData?.lastName)
			setCity(userData?.cityId)
			setEmail(userData?.email)
			setSelectedClass(userData?.insttCandidateProfile?.clssID)
			setSelectedBatch(userData?.insttCandidateProfile?.btchID || [])
			console.log("Batch Id==>", userData?.insttCandidateProfile?.btchID || [])
			const batchNamesArray = userData?.insttCandidateProfile?.batchNames || [];
			const formattedBatches = batchNamesArray.map((batch) => ({
				value: batch, // Use batch name as value
				label: batch, // Use batch name as label
			}));

			console.log(" Pre-selected Batches:", formattedBatches);

			setSelectedBatches(formattedBatches); // Set React Select values
			console.log("Formated Batch", selectedBatches)
			setBatchName(batchNamesArray); //  Set

		}
	}, [userData]);

	console.log("image type==>", profileImage, profileImageview);

	const handleFieldChangeClass = (setter, value, classNameSetter, className) => {
		setter(value);
		if (classNameSetter) {
			classNameSetter(className);
		}
	};
	const handleFieldChangeBatch = (setter, value, nameSetter, batchName) => {
		console.log("Value:", value, batchList); // Debug log
		console.log("BatchName:", batchName); // Debug log

		setter(value);
		if (nameSetter) {
			nameSetter(batchName);
		}
	};


	const [selectedBatches, setSelectedBatches] = useState([]);
	console.log("selectedBatches", selectedBatches);

	const handleChange = (selectedOptions) => {
		setSelectedBatches(selectedOptions);
		// Extract batchId and batchName separately
		const batchIds = selectedOptions.map((batch) => batch.value);
		const batchNames = selectedOptions.map((batch) => batch.label);
		setSelectedBatches(selectedOptions);
		setSelectedBatch(batchIds);
		setBatchName(batchNames);
		console.log("Selected Batches==>", batchIds)
		console.log("Selected Batches==>", batchNames)

		console.log("Batch IDs:", batchIds, "Batch Names:", batchNames);
		// setFormChanged(true);
	};

	const handleclassType = (val) => {
		console.log("class val", val);
		setClassId(val.value);
		setClassName(val.label);
		setSelectedClass(val.value)
		console.log("Val.value====>", selectedClass)

	}
	return (
		<>
			<div className="main-container settings pt-3 edit-candid">
				<div className="content-wrapper">
					<div className="title delete-title d-flex justify-content-between Title-header-Mobile">
						<h1>
							<span className="orange-box"></span> Edit Candidate
						</h1>
					</div>

					<div className="card delete-card EditCard d-flex align-center">
						<div className="post-job-details-form Edit-Card-details-form ">
							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="type">
										Class <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={ClassList}
										onChange={handleclassType}
										value={
											ClassList && ClassList?.find(
												(option) => option.value === selectedClass
											) || null
										}
										placeholder="Select class"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable

									/>
									{displays && !selectedClass ? (
										<span className="error_msg_lbl text-red">
											Select Class{" "}
										</span>
									) : null}
								</div>

								<div className="post-form-group Company-React-category">
									<label htmlFor="type">Batch</label>
									<ReactSelect
										options={batchList}
										isMulti
										value={selectedBatches}
										onChange={handleChange}
										placeholder="Select batches"
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										styles={customStyles}
										isDisabled

									/>
								</div>

							</div>
							<div className="post-form-row">
								<div className="post-form-group text-transform-email  email-label-category">
									<label htmlFor="category">
										Email
									</label>
									<input
										type="email"
										id="tag"
										placeholder="Email"
										onChange={(e) => setEmail(e.target.value)}
										value={email}
										invalid={displays && email === ""}
										className="Normal-Input-Fill"
										disabled
									/>
									{displays && !email ? (
										<span className="error_msg_lbl text-red">Enter Email </span>
									) : null}
								</div>
								<div className="post-form-group">
									<label htmlFor="type">
										Phone Number <span className="text-red">*</span>
									</label>
									<input
										type="text"
										id="tag"
										maxLength={10}
										placeholder="Enter phone number"
										onChange={(e) => setPhonenum(e.target.value)}
										// onChange={(e) => handleFieldChange(setPhonenum, e.target.value)}
										value={phonenum}
										invalid={displays && phonenum === ""}
										className="Normal-Input-Fill"
									/>
									{displays && !phonenum ? (
										<span className="error_msg_lbl text-red">
											Enter Phone Number{" "}
										</span>
									) : null}
								</div>



							</div>

							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="type">
										First Name <span className="text-red">*</span>
									</label>
									<input
										type="text"
										id="tag"
										placeholder="Enter first name"
										onChange={(e) => setFirstName(e.target.value)}
										value={firstName}
										invalid={displays && firstName === ""}
										className="Normal-Input-Fill"
									/>
									{displays && !firstName ? (
										<span className="error_msg_lbl text-red">
											Enter First Name{" "}
										</span>
									) : null}
								</div>
								<div className="post-form-group">
									<label htmlFor="tag">
										Last Name <span className="text-red">*</span>
									</label>
									<input
										type="text"
										id="tag"
										placeholder="Enter last name"
										className="Normal-Input-Fill"
										required
										onChange={(e) => setLastName(e.target.value)}
										value={lastName}
										invalid={displays && lastName === ""}
									/>
									{displays && !lastName ? (
										<span className="error_msg_lbl text-red">
											Enter Last Name{" "}
										</span>
									) : null}
								</div>



							</div>

							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="jobApplyEmail">
										DOB <span className="text-red">*</span>
									</label>
									<Flatpickr
										type="number"
										id="jobApplyEmail"
										placeholder="Dob"
										onChange={(date) => setStartDate(date[0])}
										value={startDate}
										invalid={displays && startDate === ""}
										options={{
											maxDate: new Date()
										}}
									/>
									{displays && !startDate ? (
										<span className="error_msg_lbl text-red">Enter Dob </span>
									) : null}
								</div>

								<div className="post-form-group">
									<label htmlFor="externalUrl">
										City <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={cityList}
										onChange={(option) => setCity(option ? option.value : "")}
										value={
											cityList.find((option) => option.value === city) || null
										}
										onInputChange={handleCityInputChange}
										placeholder="Search & select city"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable
									/>

									{displays && !city ? (
										<span className="error_msg_lbl text-red">Search & Select City </span>
									) : null}
								</div>


							</div>

							<div className="post-form-row">

								<div className="post-form-group">
									<label htmlFor="jobApplyType">
										Gender <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={genderOptions}
										onChange={(option) => setGenderValue(option ? option.value : "")} // Track changes
										value={
											genderOptions.find(
												(option) => option.value === genderValue
											) || null
										}
										placeholder="Select gender"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable
									/>
									{displays && !genderValue ? (
										<span className="error_msg_lbl text-red">
											Select Gender{" "}
										</span>
									) : null}
								</div>

								<div className="post-form-group profile-image-style">
									<div className="post-form-group">

										<label htmlFor="ProfileImg">Profile Image</label>
										<input
											type="file"
											id="ProfileImg"
											className="form-control Dark-Input-from-group"
											required
											accept="image/jpeg, image/png, image/jpg"
											onChange={(e) => {
												setProfileImage(e.target.files[0]);
												setProfileImageview(URL.createObjectURL(e.target.files[0]));
											}}
										/>

										{error && <span className="error_msg_lbl text-red">{error}</span>}
										{!error && !profileImage && (
											<span className="error_msg_lbl text-red">Select an image</span>
										)}
										{displays && <span className="error_msg_lbl text-red">{error}</span>}

										{displays && !profileImage ? (
											<span className="error_msg_lbl text-red">
												Upload Image{" "}
											</span>
										) : null}
									</div>

									{profileImageview && (
										<img
											className="mt-1"
											src={profileImageview}
											alt="Profile Preview"
											width={100}
										// height={75}
										// style={{ borderRadius: '50%' }}
										/>
									)}
								</div>

							</div>
							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="maxSalary">Address</label>
									<textarea
										style={{ height: '70px' }}
										type="text"
										rows={2}
										id="maxSalary"
										placeholder="Enter Address"
										onChange={(e) => setAddress(e.target.value)}
										// onChange={(e) => handleFieldChange(setAddress, e.target.value)}
										value={address}
										invalid={displays && address === ""}
										className="Normal-Input-Fill "
									/>
									{/* {displays && !about ? (
										<span className="error_msg_lbl text-red">Write About </span>
										) : null} */}
								</div>
							</div>
							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="minSalary">
										HeadLine 
									</label>
									<input
										type="text"
										id="minSalary"
										placeholder="Enter headLine"
										required
										onChange={(e) => setHeadLine(e.target.value)}
										value={headLine}
										invalid={displays && headLine === ""}
										className="Normal-Input-Fill"
									/>
									{/* {displays && !headLine ? (
										<span className="error_msg_lbl text-red">
											Enter Headline{" "}
										</span>
									) : null} */}
								</div>
								<div className="post-form-group text-transform-email">
									<label htmlFor="experience">Website </label>
									<input
										type="text"
										id="minSalary"
										placeholder="Enter website"
										onChange={(e) => setWebsite(e.target.value)}
										value={website}
										invalid={displays && website === ""}
										className="Normal-Input-Fill"
									/>
								</div>
							</div>



							<div className="post-form-row">
								<div className="post-form-group">
									<label htmlFor="about">About</label>
									<textarea
										type="text"
										id="about"
										placeholder="About"
										onChange={(e) => setAbout(e.target.value)}
										value={about}
										invalid={displays && about === ""}
										className="Normal-Input-Fill "

									/>
								</div>
							</div>

							<div className="avatar-upload-container">
								<div className="avatar-upload-section"></div>
								<button
									onClick={Profile}
									className="btn btn-primary mainBtn apply-job mb-3 mt-2"
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>


		</>
	);
}

export default EditCandidByInst;
